import { useLocation, Routes, Route, Navigate } from 'react-router-dom';
import FloatingChatButton from '../Components/ChatButton/FloatingChatButton';
import LoadingState from '../Components/Common/LoadingState';
import Footer from './Footer';
import Header from './Header';
import React, { useEffect, useState, useCallback, lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import NovedadesRouteGuard from '../Components/Hub/NovedadesRouteGuard';

const Inicio = lazy(() => import('../pages/Inicio'));
const Nosotros = lazy(() => import('../pages/Nosotros'));
const Oportunidades = lazy(() => import('../pages/Oportunidades'));
const Hub = lazy(() => import('../pages/Hub'));
const Articulo = lazy(() => import('../pages/Articulo'));
const Servicios = lazy(() => import('../pages/Servicios'));
const HubActualizaciones = lazy(() => import('../Components/Hub/noticiasArticulos/HubActualizaciones'));
const HubExperts = lazy(() => import('../Components/Hub/expertArticles/HubExperts'));
const HubNovedades = lazy(() => import('../Components/Hub/novedadesArticles/HubNovedades'));
const ArticuloNovedad = lazy(() => import('../pages/ArticuloNovedad'));
const ArticuloNoticias = lazy(() => import('../pages/ArticuloNoticias'));
const Privacidad = lazy(() => import('../pages/policies/Privacidad'));
const CondicionesDeUso = lazy(() => import('../pages/policies/CondicionesDeUso'));
const PoliticaCookies = lazy(() => import('../pages/policies/PoliticaCookies'));
const NotFound = lazy(() => import('../pages/NotFound'));

const Layout = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const [showChatModal, setShowChatModal] = useState(false);
  const [isCalendlyOpen, setIsCalendlyOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  // Detectar si el widget de Calendly está abierto
  useEffect(() => {
    let interval = null;
    if (isCalendlyOpen) {
      interval = setInterval(() => {
        const calendlyBadge = document.querySelector('.calendly-badge-widget');
        if (!calendlyBadge) {
          setIsCalendlyOpen(false);
        }
      }, 500);
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [isCalendlyOpen]);

  // Función para abrir Calendly y actualizar el estado
  const handleCalendlyOpen = useCallback(() => {
    setIsCalendlyOpen(true);
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow">
        <Suspense fallback={<LoadingState fullScreen text={t('common.loading')} />}>
          <Routes>
            <Route path="/" element={<Inicio />} />
            <Route path="/es/es-home/" element={<Navigate to="/" replace />} />
            <Route path="/es/sobre-nosotros/" element={<Navigate to="/" replace />} />
            <Route path="/en/home-1/" element={<Navigate to="/" replace />} />
            <Route path="/es/es-nuestros-serevicios/" element={<Navigate to="/" replace />} />
            <Route path="/services/inversiones/" element={<Navigate to="/" replace />} />
            <Route path="/services/" element={<Navigate to="/" replace />} />
            <Route
              path="/services_group/servicios-principal/"
              element={<Navigate to="/" replace />}
            />
            <Route path="/services/consultoria/" element={<Navigate to="/" replace />} />
            <Route path="/nosotros" element={<Nosotros />} />
            <Route path="/oportunidades" element={<Oportunidades />} />
            <Route path="/hub" element={<Hub />} />
            <Route path="/articulo/:id" element={<Articulo />} />
            <Route path="/servicios/:id" element={<Servicios />} />
            <Route path="/hub/hub-actualizaciones" element={<HubActualizaciones />} />
            <Route path="/hub/hub-experts" element={<HubExperts />} />
            <Route
              path="/hub/novedades"
              element={
                <NovedadesRouteGuard>
                  <HubNovedades />
                </NovedadesRouteGuard>
              }
            />
            <Route
              path="/hub/novedades/:id"
              element={
                <NovedadesRouteGuard>
                  <ArticuloNovedad />
                </NovedadesRouteGuard>
              }
            />
            <Route path="/hub/noticias/:id" element={<ArticuloNoticias />} />
            <Route path="/privacidad" element={<Privacidad />} />
            <Route path="/condiciones-de-uso" element={<CondicionesDeUso />} />
            <Route path="/politica-cookies" element={<PoliticaCookies />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </main>
      {<Footer />}
      <FloatingChatButton />
    </div>
  );
};

export default Layout;
